import { TSearchQuery } from '../store/header/types';
import { filterArrayByAcronym } from '../../../helpers/search/filterArrayByAcronym';
import { ITemplate } from '../store/templates/types';

export const filterTemplatesForSearch = (
    templates: ITemplate[],
    searchQuery: TSearchQuery
): ITemplate[] => {
    return filterArrayByAcronym(templates, 'name', searchQuery);
};
